<ds-combo-box [(ngModel)]="innerValue" [label]="" [selectedHtml]="selectedHtml" [disabled]="isDisabled">
  <ds-combo-box-dropdown
    [attr.name]="'combo-box-dropdown'"
    [initialValue]="[initialCountry]"
    [searchPlaceholder]="searchPlaceholder"
    [hideSearchPlaceholderWhenFilled]="true"
    [hideSearchPlaceholderWhenFocused]="false"
    class="mt-2 me-2"
  >
    <ds-combo-box-dropdown-group maxHeight="12.5rem" class="mb-3">
      <ds-combo-box-dropdown-option *ngFor="let country of countryList"
                                    [label]="country.name"
                                    [value]="country.isocode"
                                    (elementClick)="changeFlag($event)"
                                    class="me-1">
        <div class="d-flex flex-nowrap justify-content-start align-items-center">
          <div class="ds-flag-wrapper me-2">
            <span class="ds-flag--{{country.isocode.toLowerCase()}}"></span>
          </div>
          <span [innerHTML]="country.name | textSearchHighlight:innerComboBox.comboBoxGroup.searchInput"
                class="ds-color--grey-1">
          </span>
        </div>
      </ds-combo-box-dropdown-option>
    </ds-combo-box-dropdown-group>
  </ds-combo-box-dropdown>
</ds-combo-box>
